import { BrowserFeatureDetector } from "./BrowserFeatureDetector";

const SAFARI_RESIZE_DELAY = 150;

const doOnResize = (action: () => void): void => {
  if (BrowserFeatureDetector.isSafari()) {
    // resize event on Safari is delivered before document layout - when resizing animations
    // lottie will get old container dimensions. As a hacky workaround we trigger lottie resize with a small delay
    // https://openradar.appspot.com/radar?id=5040881597939712
    setTimeout(action, SAFARI_RESIZE_DELAY);
  } else {
    action();
  }
};

export const WindowResizeHelper = {
  doOnResize
};